import { DmThumbnail, IDmData, getDmIcon, panelType } from '@bimser/common';
import { BCCard, BCList, BCSkeleton, ContentType, findMessage } from '@bimser/components';
import IconHover from '@bimser/icons/16/sub-menu-arrow';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import Style from '../../assets/style.scss';
import IRecentFilesProps from '../../entities/widgets/IRecentFilesProps';
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const recentFilesEmpty = require('../../../../assets/recent-files-empty.svg');

export default (props: IRecentFilesProps) => {
	const onClickFile = (file: IDmData) => {
		props.onClickFile({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: file
		});
	};

	const renderIcon = (item: IDmData) => {
		const defaultIcon = getDmIcon(item.type, null, item.name);

		if (item.existThumbnail) {
			return (
				<DmThumbnail
					key={`thumbnail_${item.secretKey}`}
					defaultIcon={defaultIcon}
					secretKey={item.secretKey}
					iconSize={32}
				/>
			);
		}

		return defaultIcon;
	};

	const renderCustomEmpty = () => (
		<div
			data-selenium-id="dashboardRecentFilesEmptyView"
			className={Style.emptyView}
		>
			<img
				src={recentFilesEmpty.default}
				className={Style.emptyViewImg}
			/>
			<span className={Style.emptyViewTitle}>{findMessage.get('102975')}</span>
			<span className={Style.emptyViewDesc}>{findMessage.get('102976')}</span>
		</div>
	);

	const renderItem = (item: IDmData) => (
		<div
			className={Style.recentFileItemContainer}
			onClick={() => onClickFile(item)}
		>
			<div className={Style.recentFileItem}>
				<div className={Style.recentFileItemIcon}>{renderIcon(item)}</div>
				<div className={Style.recentFileItemText}>
					<span className={Style.recentFileItemName}>{item.name}</span>
					<span
						className={Style.recentFileItemCreateInfo}
						title={dayjs(item.recentCreatedAt).format('L LTS')}
					>
						{findMessage
							.get('102978')
							.replace('${0}', dayjs(item.recentCreatedAt).fromNow())}
					</span>
				</div>
			</div>
			<IconHover className={Style.iconHover} />
		</div>
	);

	const renderHeader = (
		<div className={Style.recentFilesHeader}>
			<span className={Style.widgetHeader}>{findMessage.get('100861')}</span>
		</div>
	);

	return props.data.length ? (
		<BCCard
			bordered={false}
			className={Style.recentFilesContainer}
			title={renderHeader}
			seleniumId="dashboardRecentFilesCard"
		>
			<BCSkeleton
				loadingStatus={props.loading}
				contentType={ContentType.DashboardRecentFilesList}
			>
				<BCList
					bordered={false}
					dataSource={props.data}
					customEmpty={renderCustomEmpty()}
					renderItem={renderItem}
					className={Style.recentFilesList}
				/>
			</BCSkeleton>
		</BCCard>
	) : (
		<></>
	);
};
